var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kun_loading111_container"},[_c('div',{attrs:{"id":"page"}},[_c('div',{attrs:{"id":"container"}},[_c('div',{attrs:{"id":"ring"}}),_c('div',{attrs:{"id":"ring"}}),_c('div',{attrs:{"id":"ring"}}),_c('div',{attrs:{"id":"ring"}}),_c('div',{attrs:{"id":"h3"}},[_vm._v("loading")])])])])
}]

export { render, staticRenderFns }